import axios from "axios";
import { useState, useEffect } from "react";

const UseBranchInfo = () => {
  const [branchInfo, setBranchInfo] = useState([]);
  const [loading, setLoading] = useState(false);

  const rupali_api_url = process.env.REACT_APP_RUPALI_API_HOST;
  // console.log("Branch URL", rupali_api_url);

  const url = `${rupali_api_url}/Api/WebSite/BranchInfo`;

  useEffect(() => {
    axios.get(url).then((res) => {
      // axios.get("API/webApi/BranchInfo").then((res) => {
      setBranchInfo(res.data.data);
      setLoading(true);
    });
  }, []);

  return [branchInfo, setBranchInfo, loading];
};

export default UseBranchInfo;
